import { View } from 'backbone';
import { Model } from 'backbone';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import listService      from 'ListService.js';
import formatTemplate from 'behaviors/properties/main/select-object.ejs';
import undoService from 'UndoService.js';
import _ from 'lodash';
import PageButtonControlView from "../../../common-visuals/PageButtonControlView";
import textConstants from "../../../../constants/TextConstants";

class MainSelectObjectView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.mode = 'form';
        this.viewTitle= _.get(opts, 'config.viewTitle') || 'Object Selection';
        this.label= _.get(opts, 'config.label') || 'Object';

        this.events = {
            "click #selectObject"     : "showSelectModal"
        };

        if (!this.model.get('ValueOfAField')) {
            this.model.set('ValueOfAField', '', {silent: true});
            this.model.set('ValueOfAFieldId', '', {silent: true});
        }

        if (this.model.get('factoryKey') === 'command_show') {
            this.model.set('sectionTitle', 'Show Property Settings', {silent: true});
            this.model.set('label', this.label, {silent: true});
            this.mode = 'object';
        } else {
            this.model.set('sectionTitle', this.viewTitle, {silent: true});
            this.model.set('label', this.label, {silent: true});
        }

        if (this.model.get('controlId')) {
            const id = this.model.get('controlId');
            let object = listService.getObject( listService.cleanId(id)) ?
                    listService.getObject( listService.cleanId(id)) :
                // PF-2163 Searching through pages also.
                    listService.getPage( listService.getObjectByCleanedId(id) );
            const objName = object ? object.model.get('name') : '';
            this.model.set('ValueOfAField', objName, {silent:true});
            if (this.model.get('autosummary')) {
                this.model.set('widgetText', objName, {silent:true});
            }
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    showSelectModal(ev) {
        ev.preventDefault();
        const oldControlId=this.model.get('controlId');
        const oldValueOfAField=this.model.get('ValueOfAField');
        const factoryKey= 'modal';
        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get("controlId"), {silent:true});
        var sfModal = new selectFieldModalView({model: sfModel, mode: 'objectsANDlists',
                                                target:this.model.get('factoryKey')});
        sfModal.render().then((selectedField)=>{
            this.model.set('controlId', selectedField.id, {silent:true});
            this.model.set('ValueOfAField', selectedField.name,{silent:true});
            this.updateWidgetText();
            this.model.trigger("loadRelatedFields");
            this.render();
            undoService.add({
                undo:() =>{
                    this.model.set('controlId',oldControlId,{silent:true});
                    this.model.set('ValueOfAField',oldValueOfAField,{silent:true});
                    this.updateWidgetText();
                    this.render();
                },
                redo:() =>{
                    this.model.set('controlId',selectedField.id,{silent:true});
                    this.model.set('ValueOfAField',selectedField.name,{silent:true});
                    this.updateWidgetText();
                    this.render();
                }
            },textConstants.UNDO_SELECT_OBJECT)
        }).catch(err => console.log(err));
    }

    updateWidgetText(){
        if (this.model.get('autosummary')) {
            this.model.set('widgetText', this.model.get('ValueOfAField'),{silent:true});
            this.model.trigger('widgetTextUpdated')
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainSelectObjectView;
